<template>
  <v-parallax 
    :src="getImgUrl(inspiracao)" height="400"
  >
    <div style="
      background-color: rgba(0, 0, 0, 0.75);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    "></div>
    <v-row class="align-center justify-center text-center" pb-4 style="position: relative">
      <v-col cols="12">
        <div v-if="!enviado" class="display-1 white--text font-weight-bold text-xs-center">
          <span class="barlow">Sua Mensagem de Inspiração Semanal</span>
        </div>
        
        <v-container fluid>
          <v-form
            ref="form" dark
            v-model="valid"
          >
            <v-row v-if="!enviado" class="justify-center px-8 pt-4">
              <v-col cols="12" md="4" class="d-block py-0">
                <v-text-field
                  dark filled dense 
                  type='nome'
                  v-model="form.nome"
                  :rules="nomeRules"
                  label="Nome"
                  required
                  class="white--text"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="d-block py-0">
                <v-text-field
                  dark filled dense 
                  type='email'
                  v-model="form.email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                  class="white--text"
                ></v-text-field>
              </v-col>
              <v-col cols="auto" class="py-0">
                <v-btn
                  x-large 
                  color="white primary--text"
                  class="text-left"
                  @click="submit"
                  :loading="loading"
                  :disabled="loading"
                >
                  <span class="font-weight-bold">Inscrever</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        
          <v-row
            v-if="enviado"
            class="justify-center"
          >
            <v-col cols="8">
              <v-icon x-large color="white">mdi-check</v-icon>
              <h3 class="display-1">
                <span class="primary--text">E-mail cadastrado com sucesso!</span>
              </h3>
              <h4 class="subtitle-1">
                <span>Agradecemos o seu cadastro! Agora você passará a receber inspirações semanais.</span>
              </h4>
            </v-col>
          </v-row>
        </v-container>
        
      </v-col>
    </v-row>
  </v-parallax>
</template>

<script>
import axios from 'axios'
// import swal from 'sweetalert'
let qs = require('qs')

export default {
  data () {
    return {
      inspiracao: 'newsletter.jpg',
      loading: false,
      valid: false,
      enviado: false,
      form: {
        lista: 98,
        nome: '',
        email: ''
      },
      nomeRules: [
        (v) => !!v || 'Informe seu nome'
      ],
      emailRules: [
        (v) => !!v || 'Informe seu e-mail',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Informe um e-mail válido'
      ],
    }
  },
  methods: {
    getImgUrl(i) {
      return require('@/assets/img/'+i)
    },
    submit () {
      var vm = this
      if (this.$refs.form.validate()) {

        let params = qs.stringify({
          form: vm.form
        })
        vm.loading = true //the loading begin
        axios.post('https://api.otimizze.me/v0/leads/post3/', params)
          .then(response => {
            vm.loading = false
            if (response.status === 200) {
              // swal("Contato realizado com sucesso!", "Em breve entraremos em contato.", "success", {
              //   button: "Fechar"
              // })
              //vm.dialog = false
              this.enviado = true
              this.reset()

              // DISPARA EVENTO FACEBOOK
              //fbq('track', 'Lead')

              // DISPARA EVENTO GOOGLE
//              gtag('event', 'clique', {
//                'event_category': 'enviar'
//              })
//              console.log('evento disparado')

              //vm.$router.push({ path: '/obrigado' })
              //window.open('https://pag.ae/7UZDywNcL')
            } else if (response.status === "error") {
              console.error("Log >>> Erro na gravação");
            }
          }).catch(e => {
            console.error('AXIOS CATCH', e)
            vm.loading = false
          })
      }
      else {
        console.error('não validou')
      }
    },
  }
}
</script>